import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

function Consultation() {
    const { t } = useTranslation();
    const location = useLocation();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        text: '',
        checkbox: false
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        if (location.state) {
            setFormData(prev => ({ ...prev, ...location.state }));
        }
    }, [location.state]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async () => {
        const { name, email, phone, text, checkbox } = formData;

        if (!name || !email || !phone || !text || !checkbox) {
            setMessage({ type: 'error', text: t('cons.fill_all') });
            return;
        }

        setLoading(true);
        setMessage({ type: '', text: '' });

        try {
            await axios.post('https://civbt.xyz/api/bot/gmryAzaJDp', formData);
            setMessage({ type: 'success', text: t('cons.success') });
            setFormData({
                name: '',
                email: '',
                phone: '',
                text: '',
                checkbox: false
            });
        } catch (error) {
            console.error(error);
            setMessage({ type: 'error', text: t('cons.error') });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-[#F4F1E8] pt-[80px] xl:pt-[140px]">
            <div className="max-w-[915px] mx-[20px] xl:mx-auto flex flex-col items-center">
                <p className="host-grostesk leading-[1.2] text-[28px] xl:text-[40px] max-w-[350px] sm:max-w-max text-center">{t('cons.1')}</p>
                <p className="text-[#000000B2] PtRoot text-[12px] xl:text-[14px] md:max-w-[517px] text-center mt-[10px]">{t('cons.2')}</p>
                <p className="text-center text-[12px] xl:text-[14px] font-[700] text-[#000000B2] PtRoot bg-[#EAE6DA] py-[12px] mt-[12px] w-full rounded-[5px] px-[20px]">{t('cons.3')}</p>
                <div className="flex flex-col xl:flex-row gap-[12px] xl:gap-[40px] w-full mt-[40px]">
                    <div className="w-full flex flex-col gap-[12px]">
                        <div>
                            <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">{t('cons.4')}</p>
                            <input
                                name="name"
                                value={formData.name}
                                type="text"
                                onChange={handleChange}
                                placeholder={t('cons.5')}
                                className="PtRoot w-full border-[2px] xl:border-[1px] border-[#0000001A] bg-transparent rounded-md px-[32px] py-3 text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080]"
                            />
                        </div>
                        <div>
                            <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">{t('cons.6')}</p>
                            <input
                                name="email"
                                value={formData.email}
                                type="text"
                                onChange={handleChange}
                                placeholder={t('cons.7')}
                                className="PtRoot w-full border-[2px] xl:border-[1px] border-[#0000001A] bg-transparent rounded-md px-[32px] py-3 text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080]"
                            />
                        </div>
                        <div>
                            <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">{t('cons.8')}</p>
                            <input
                                name="phone"
                                value={formData.phone}
                                type="text"
                                onChange={handleChange}
                                placeholder={t('cons.9')}
                                className="PtRoot w-full border-[2px] xl:border-[1px] border-[#0000001A] bg-transparent rounded-md px-[32px] py-3 text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080]"
                            />
                        </div>
                    </div>
                    <div className="w-full">
                        <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">{t('cons.10')}</p>
                        <textarea
                            name="text"
                            value={formData.text}
                            onChange={handleChange}
                            placeholder={t('cons.11')}
                            rows={3}
                            className="PtRoot w-full border-[2px] xl:border-[1px] border-[#0000001A] bg-transparent rounded-md px-[32px] py-3 h-[194px] text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080] resize-none"
                        ></textarea>
                    </div>
                </div>

                <label className="flex items-center mr-auto gap-2 text-[12px] xl:text-[14px] text-[#000000B2] cursor-pointer PtRoot font-[700] mt-[20px]">
                    <input
                        name="checkbox"
                        type="checkbox"
                        checked={formData.checkbox}
                        onChange={handleChange}
                        className="accent-[#E95420] w-[14px] h-[14px]"
                    />
                    {t('cons.12')}
                </label>

                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="rounded-[8px] bg-[#FC2E00] mt-[20px] xl:mt-[32px] text-white uppercase PtRoot font-[700] py-[14px] px-[40px] hover:px-[20px] transition-all disabled:opacity-50"
                >
                    {loading ? t('cons.sending') : t('home.46')}
                </button>

                {message.text && (
                    <p className={`mt-4 text-[14px] ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                        {message.text}
                    </p>
                )}
            </div>
        </div>
    );
}

export default Consultation;
